import { CaseReducer, createSlice, PayloadAction } from '@reduxjs/toolkit';

type SystemNotification = {
  id: string;
  key: string;
  message: string;
  type: string;
};

export type SystemNotificationsState = {
  collection: SystemNotification[];
};

const initialState: SystemNotificationsState = {
  collection: [],
};

type SystemNotificationsReducers = {
  hideNotificationAction: CaseReducer<
    SystemNotificationsState,
    PayloadAction<string>
  >;
  showNotificationAction: CaseReducer<
    SystemNotificationsState,
    PayloadAction<SystemNotification>
  >;
};

const addNotification = (
  collection: SystemNotification[],
  notification: SystemNotification,
): SystemNotification[] => {
  const { key } = notification;
  let result = [...collection];

  if (key) {
    result = result.filter((item) => item.key !== key);
  }

  return [...result, notification];
};

const systemNotifications = createSlice<
  SystemNotificationsState,
  SystemNotificationsReducers,
  'systemNotifications',
  never
>({
  name: 'systemNotifications',
  initialState,
  reducers: {
    hideNotificationAction: (state, { payload: notificationId }) => ({
      ...state,
      collection: state.collection.filter(({ id }) => id !== notificationId),
    }),
    showNotificationAction: (state, { payload: notification }) => ({
      ...state,
      collection: addNotification(state.collection, notification),
    }),
  },
});

export const { hideNotificationAction, showNotificationAction } =
  systemNotifications.actions;

export default systemNotifications.reducer;
